module.exports = "/assets/data/0bd7843001739d94529a31e33a48c4ec-BT26.data.json";